import {override} from 'mobx';
import {DatetimeUtils} from "../../../../../infrastructure/utils/datetime-utils";
import {RedirectModel} from "./redirect-model";
import {DASHBOARD} from "../../../../../containers/dashboard-container/dashboard-container.consts";
import {DEFAULT_CULTURE_NAME} from "../../../../app/consts";

export class YesterdayRedirectModel extends RedirectModel {
  name: String;
  cultureName: String;

  constructor(name: String, cultureName: String, datetimeUtils: DatetimeUtils) {
    super(name, cultureName);

    this.datetimeUtils = datetimeUtils;
  }

  @override get from() {
    const yesterday: Date = this.datetimeUtils.getRelativeDate(-1);
    const urlDate = this.datetimeUtils.toURLDate(yesterday.midnight())

    return `${this.languageDisplayName}/:sportName/${urlDate}`;
  }

  @override get to() {
    const sportName: String = this.cultureName === DEFAULT_CULTURE_NAME ? this.currentPathParams[1]: this.currentPathParams[2];

    return `${this.languageDisplayName}/${sportName}/${DASHBOARD.FILTERS.yesterday}`;
  }
}